import Image from 'next/image';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ValSellTime: React.FC<{
  onForward: (sellTime: string) => void;
}> = ({ onForward }) => {
  const { t } = useTranslation(['valutatore']);
  const { t: tc } = useTranslation();
  const [sellTime, setSellTime] = useState<string>('');

  return (
    <>
      <div className="valutatore__container__title">
        <Image
          src="/assets/img/valutatore/tempivendita.jpg"
          alt="tempivendita"
          width={32}
          height={32}
        />
        {t('step_five.title')}
      </div>
      <div className="valutatore__container--two_columns">
        {(t('step_five.time') as string[]).map((val: string, index: number) => (
          <div
            key={index}
            className={
              'valutatore__container__choiche' +
              (sellTime === val
                ? ' valutatore__container__choiche--selected'
                : '')
            }
            onClick={() => setSellTime(val)}
          >
            {val}
          </div>
        ))}
      </div>
      {!!sellTime && (
        <div
          className="valutatore__container__button_forward"
          onClick={() => onForward(sellTime)}
        >
          {tc('next')}
        </div>
      )}
    </>
  );
};
